export default {
  region: "ap-southeast-2",
  IdentityPoolId: "ap-southeast-2_w6bT73AY8",
  UserPoolId: "ap-southeast-2:693181236168",
  ClientId: "1ebtl8u681ojssket2ihp4n9s1"
};
